"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ARViewer {
    constructor() {
        this.modelUrl = null;
        this.modelUrl = null;
    }
}
exports.default = ARViewer;
